import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
export class GameTextUtil {
    /**
     * Force initialisation of TitanText, normally done on its first render.
     * This prevents the very noticable stuttering when a text first becomes visible.
     */
    static forceInitialise(...texts) {
        for (const text of texts) {
            text.getPixiText(); // This forces the text to initialise its PixiJS Text object.
        }
    }
    static centerProperties(...texts) {
        for (const text of texts) {
            if (text.verticalAlign === ControlConstants.CENTER) {
                const size = (text.size?.y) ?? 0;
                text.position.y -= size / 2;
                continue;
            }
            else if (text.verticalAlign === ControlConstants.BOTTOM) {
                const size = (text.size?.y) ?? 0;
                text.position.y -= size;
            }
        }
    }
}
//# sourceMappingURL=GameTextUtil.js.map